import "./add_recipe.css";
import SanityForm from "./sanity_form";
function AddRecipe() {
  return (
    <div className="add_recipe">
      <br></br>
      <br></br>

      <br></br>

      <div className="form_section">
        <h3>Add Recipe</h3>
        <br></br>

        <SanityForm />
      </div>
    </div>
  );
}

export default AddRecipe;
